// Latest-wins ticket for list fetches that can overlap.
//
// The Active/Completed Assessments lists are requested from several places
// (page mount, the College/Corporate tab switch, debounced filters) and the
// college query is markedly slower than the corporate one, so a request issued
// earlier can resolve *after* a later one. Whoever resolves last used to win
// the store — which put institute rows under the Corporate tab, and opening
// one asked the backend for an institute map as a corporate map (404
// "Assessment not found"). Only the newest request may write to the store.
//
//   const ticket = latestRequest('activeAssessments')
//   const data = await fetch(...)
//   if (!ticket.isLatest()) return data   // superseded — do not dispatch
const sequences = {}

const latestRequest = key => {
  sequences[key] = (sequences[key] || 0) + 1
  const seq = sequences[key]
  return { seq, isLatest: () => sequences[key] === seq }
}

module.exports = { latestRequest }
